export const AUTOMATION_REQUEST = 'automationRequest';
export const AUTOMATION_NAME = 'automationName';
export const AUTOMATION_TYPE = 'automationType';
export const EXECUTION_ENVIRONMENT = 'executionEnvironment';
export const IS_WINDOWS_APPLICATION_AUTOMATION = 'isWindowsApplicationAutomation';
export const EMAIL_ADDRESS = 'emailAddress';
